import React from 'react';

export const SourceTypeFloat = (props: { size: number } = { size: 24 }) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="new-Icon/source_float"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="source_float" transform="translate(0.200000, 0.000000)">
        <rect
          id="bck-SorceDataType"
          fill="#575757"
          x="0"
          y="0"
          width="32"
          height="32"
          rx="2"
        ></rect>
        <path
          d="M5.33333333,23.1893333 L5.33333333,8 L11.8186667,8 L11.8186667,10.048 L7.50933333,10.048 L7.50933333,14.656 L11.264,14.656 L11.264,16.704 L7.50933333,16.704 L7.50933333,23.1893333 L5.33333333,23.1893333 Z M13.2266667,23.1893333 L13.2266667,8 L15.4026667,8 L15.4026667,21.0133333 L19.712,21.0133333 L19.712,23.1893333 L13.2266667,23.1893333 Z M22.5493333,23.1893333 L22.5493333,10.048 L20.032,10.048 L20.032,8 L27.2426667,8 L27.2426667,10.048 L24.7253333,10.048 L24.7253333,23.1893333 L22.5493333,23.1893333 Z"
          id="FLT"
          fill="#FFFFFF"
        ></path>
      </g>
    </g>
  </svg>
);
